import type { Messages } from "../types";

export const fr = {
  "common": {
    "brand": "UN8",
    "brandTag": "Rencontres chrétiennes exclusives",
    "continue": "Continuer",
    "leave": "Partir",
    "leaveForNow": "Partir pour l'instant",
    "yes": "Oui",
    "no": "Non",
    "goBack": "Retourner",
    "saving": "Économie…",
    "submitting": "Soumission…",
    "pleaseWait": "S'il vous plaît, attendez…",
    "ellipsis": "…",
    "male": "Mâle",
    "female": "Femelle",
    "phases": {
      "gate": "Grille",
      "verify": "Vérifier",
      "setup": "Installation",
      "profile": "Profil"
    },
    "storageQuota": "Ce téléphone n'a plus d'espace pour les réponses enregistrées. Libérez de l'espace de stockage, puis réessayez.",
    "storageDisabled": "Ce navigateur n'enregistrera pas vos réponses. Désactivez le mode privé ou autorisez les données du site, puis rechargez.",
    "charMeta": "{len}/{min} min · {current}/{max}",
    "charMetaMin": "min. de caractères {min}"
  },
  "welcome": {
    "promise": "Notre objectif est que vous supprimiez cette application le plus rapidement possible.",
    "sub": "UN8 aide les célibataires chrétiens sérieux à trouver un partenaire de vie, puis à partir. Vérifié. Les valeurs avant tout. Pas de balayage sans fin.",
    "signedInAs": "Connecté sous le nom {email}",
    "liveServer": "· serveur en direct",
    "deviceOnly": "· cet appareil uniquement",
    "migrateOffer": "Cet appareil a toujours un profil local. Le télécharger sur le serveur partagé afin que les autres téléphones puissent vous voir après modération ? Rien n'est téléchargé jusqu'à ce que vous choisissiez.",
    "uploadLocalProfile": "Télécharger mon profil local",
    "keepOnDevice": "Conservez-le uniquement sur cet appareil",
    "migrateNeedGender": "Choisissez d'abord Homme ou Femme dans votre profil.",
    "migrateDone": "Texte du profil téléchargé. Téléchargez à nouveau votre pièce d'identité, votre vidéo et vos photos afin que la modération puisse les examiner.",
    "deleteConfirm": "Supprimer définitivement votre compte, tous les messages et tous les médias (y compris les identifiants et les vidéos) du serveur ?",
    "accountDeleted": "Compte supprimé.",
    "begin": "Commencer",
    "continueOnboarding": "Continuer l'intégration",
    "logIn": "Se connecter",
    "logOut": "Se déconnecter",
    "reviewConsole": "Console de révision",
    "matching": "Correspondance",
    "deleteMyAccount": "Supprimer mon compte"
  },
  "faith": {
    "eyebrow": "Porte de la foi",
    "title": "Chrétiens seulement",
    "text": "UN8 est une communauté de disciples de Jésus-Christ, destinée aux membres à la recherche d'un partenaire soucieux du mariage et partageant cette foi. Cette porte ne peut pas être ignorée.",
    "yesTitle": "je suis chrétien",
    "yesBody": "Je suis Jésus-Christ et cherche un partenaire soucieux du mariage qui partage cette foi.",
    "noTitle": "je ne suis pas chrétien",
    "noBody": "UN8 n'est pas le bon endroit pour moi – et ce n'est pas grave.",
    "respectTitle": "Avec respect",
    "respectBody": "UN8 est conçu pour une seule communauté, et nous préférons être honnêtes plutôt que de vous faire perdre du temps. Utilisez Laisser ci-dessous ou Retour si ce n'est pas votre domicile.",
    "sharedTitle": "Fondation partagée",
    "sharedBody": "La foi n'est pas une étiquette ici. C'est le terrain sur lequel vous vous retrouvez.",
    "hintNotChristian": "UN8 est destiné aux disciples de Jésus-Christ. Appuyez sur Quitter ci-dessous ou choisissez l’option Chrétienne si c’est votre cas.",
    "hintUnset": "Appuyez sur « Je suis chrétien » pour continuer, ou sur Quitter/Retour si ce n'est pas votre domicile."
  },
  "rules": {
    "eyebrow": "Pacte communautaire",
    "title": "Comment nous nous traitons les uns les autres",
    "text": "Affirmez chaque règle. Les trois sont obligatoires. Les violations entraînent une suppression définitive. Les faux profils sont interdits pour toujours.",
    "agreeContinue": "Je suis d'accord — continuer",
    "respectful": {
      "title": "Soyez respectueux",
      "description": "Parlez et agissez avec dignité. Chaque personne ici est créée à l’image de Dieu."
    },
    "noSexualContent": {
      "title": "Aucun contenu sexuel",
      "description": "Pas de photos, messages ou demandes explicites. La pureté n'est pas facultative ici."
    },
    "noDominance": {
      "title": "Ne pas dominer ou contrôler",
      "description": "Aucune coercition, manipulation ou pression. L'amour ne contrôle pas."
    },
    "hint": "Cochez les trois promesses avant de continuer."
  },
  "intent": {
    "eyebrow": "",
    "title": "Tu cherches quoi ?",
    "text": "",
    "marriage": {
      "label": "Un partenaire pour la vie",
      "description": ""
    },
    "discernment": {
      "label": "Discerner sérieusement",
      "description": ""
    },
    "notCasual": {
      "label": "Rien de léger",
      "description": ""
    },
    "hint": "Choisis-en une."
  },
  "account": {
    "eyebrow": "Compte",
    "title": "Créez votre accès",
    "text": "Votre identifiant crée un identifiant utilisateur stable. L'application, la vérification, les likes et les correspondances sont tous liés à cet identifiant. Aucun email n'est envoyé.",
    "recoveryTitle": "Enregistrez votre code de récupération",
    "recoveryText": "Montré une fois. Sans cela, une phrase secrète perdue ne peut pas être réinitialisée dans ce test fermé.",
    "savedContinue": "Je l'ai enregistré — continuer",
    "handle": "Poignée",
    "handlePlaceholder": "you@example.com ou un court identifiant",
    "passphrase": "Phrase secrète",
    "passphrasePlaceholder": "Au moins 8 caractères",
    "signedInTitle": "Connecté",
    "signedInBody": "{email} · {userId}",
    "trustTitle": "Norme de confiance",
    "trustBody": "Aucun profil n'est visible tant que la vérification d'identité n'est pas terminée et que la modération ne vous approuve pas.",
    "continueToVerification": "Continuer la vérification",
    "hintEmail": "Tapez une adresse e-mail comprenant @.",
    "hintPassword": "Choisissez un mot de passe d'au moins 8 caractères."
  },
  "verify": {
    "intro": {
      "eyebrow": "Vérification",
      "title": "La confiance est la porte",
      "text": "Téléchargez une pièce d'identité gouvernementale, une vidéo de confirmation et de vraies photos {min} – {max}. Tout entre dans une file d’attente de révision avant que votre profil puisse apparaître.",
      "whyTitle": "Pourquoi nous vérifions",
      "whyBody": "La pêche au chat et les demi-vérités n’ont pas leur place ici. Les faux profils sont bannis définitivement. Le média est stocké avec le statut pending_review jusqu'à son approbation.",
      "start": "Commencer la vérification"
    },
    "steps": {
      "id": {
        "title": "Carte d'identité gouvernementale",
        "description": "Passeport ou carte d'identité nationale – appareil photo ou téléchargement de fichiers."
      },
      "video": {
        "title": "Vidéo de confirmation",
        "description": "Un court enregistrement qui prouve que vous êtes présent."
      },
      "photos": {
        "title": "De vraies photos",
        "description": "Sept à dix photos claires de vous."
      },
      "review": {
        "title": "Examen d'intégrité",
        "description": "Les téléchargements restent pending_review jusqu'à ce que le personnel confirme."
      }
    },
    "id": {
      "eyebrow": "Étape 1 sur 4",
      "title": "Carte d'identité gouvernementale",
      "text": "Capturez ou téléchargez votre passeport ou votre carte d'identité nationale. Rien n'est publié publiquement : le statut reste pending_review jusqu'à ce que le personnel le confirme.",
      "savedTitle": "Identifiant enregistré",
      "savedBody": "Vient ensuite une courte vidéo de confirmation de votre visage, puis 7 à 10 vraies photos de vous. Continuer à se déverrouiller lorsque cet identifiant est enregistré.",
      "hint": "Prenez ou téléchargez une photo de votre pièce d'identité gouvernementale, puis attendez qu'elle soit indiquée comme enregistrée."
    },
    "video": {
      "eyebrow": "Étape 2 sur 4",
      "title": "Vidéo de confirmation",
      "text": "Enregistrez un court clip ou téléchargez-en un. Faites face à la caméra. Parlez clairement. Cela prouve que vous êtes présent – ​​pas une galerie grattée.",
      "hint": "Enregistrez une courte vidéo de confirmation, puis attendez qu'elle indique enregistré."
    },
    "photos": {
      "eyebrow": "Étape 3 sur 4",
      "title": "De vraies photos",
      "text": "Ajoutez {min}–10 photos récentes de vous-même. Utilisez l'appareil photo ou votre bibliothèque. Appuyez sur × pour supprimer une photo.",
      "continueToReview": "Continuer à réviser",
      "hint": "Ajoutez {min} à 10 photos claires de vous-même. Continuez les déverrouillages lorsqu'ils sont enregistrés."
    },
    "review": {
      "eyebrow": "Étape 4 sur 4",
      "title": "Examen d'intégrité",
      "text": "Le média est mis en file d'attente sous le nom pending_review{underUser}. Les correspondances et les likes utiliseront le même identifiant.",
      "underUser": "sous l'utilisateur {userId}",
      "governmentId": "Carte d'identité gouvernementale",
      "confirmationVideo": "Vidéo de confirmation",
      "photos": "Photos",
      "missing": "Manquant",
      "filesReady": "Fichiers {count} prêts",
      "submittedTitle": "Soumis pour examen",
      "submittedText": "L'identifiant de l'application est égal à l'identifiant de l'utilisateur d'authentification, donc approuvez → le pool et les likes mutuels restent alignés.",
      "submitContinue": "Soumettre et continuer"
    }
  },
  "setup": {
    "eyebrow": "Configuration du compte",
    "title": "Dites la vérité sur vous-même",
    "text": "Ces réponses façonnent l’appariement et apparaissent dans la revue. Les mensonges légers font perdre du temps à tout le monde, y compris le vôtre.",
    "beginSetup": "Commencer la configuration",
    "pillars": {
      "faith": {
        "name": "Foi",
        "text": "Pourquoi suivez-vous Christ."
      },
      "character": {
        "name": "Personnage",
        "text": "Loyauté, honnêteté, passion, engagement – ​​notés de 1 à 10."
      },
      "story": {
        "name": "Histoire",
        "text": "Qui vous êtes et ce que vous recherchez."
      },
      "life": {
        "name": "Vie",
        "text": "Loisirs, lecture et vocation."
      }
    },
    "whyChristian": {
      "eyebrow": "Foi",
      "title": "Pourquoi es-tu chrétien ?",
      "text": "Une réponse courte et honnête. Pas un sermon – une raison qui vous appartient.",
      "label": "Votre Réponse",
      "placeholder": "par ex. J’ai rencontré Christ dans une période de perte et je l’ai suivi depuis…",
      "hint": "Écrivez au moins des caractères {min} expliquant pourquoi vous suivez Jésus."
    }
  },
  "scales": {
    "eyebrow": "Échelles de caractères",
    "title": "Évaluez-vous honnêtement",
    "text": "Loyauté, honnêteté, passion, engagement – ​​chacun de 1 à 10. Gonfler les chiffres ne vous confondra que plus tard. Vous devez configurer chaque échelle pour continuer.",
    "loyalty": {
      "label": "Niveau de fidélité",
      "hint": "Soyez honnête : avec quelle fidélité soutenez-vous ceux que vous aimez ?"
    },
    "honesty": {
      "label": "Niveau d'honnêteté",
      "hint": "Avec quelle régularité dites-vous toute la vérité ?"
    },
    "passion": {
      "label": "À quel point êtes-vous passionné ?",
      "hint": "Conviction et profondeur – pas performance."
    },
    "commitment": {
      "label": "Niveau d'engagement",
      "hint": "Êtes-vous prêt à construire quelque chose qui dure ?"
    },
    "hint": "Déplacez chaque curseur pour qu’un nombre s’affiche – aucun ne peut rester sous forme de tiret."
  },
  "about": {
    "eyebrow": "Au propos de vous",
    "title": "Décrivez-vous en quelques phrases",
    "text": "Qui vous êtes quand personne ne joue. Le tempérament, le rythme, ce qui compte au quotidien.",
    "label": "Au propos de vous",
    "placeholder": "Matins tranquilles, sérieux en famille, rire facilement, préférer la profondeur au bruit…",
    "hint": "Écrivez au moins des caractères {min} sur vous-même."
  },
  "looking": {
    "eyebrow": "Partenaire",
    "title": "Qu'est-ce que tu cherches?",
    "text": "Principaux traits de caractère que vous désirez chez un partenaire potentiel – pas une liste de looks.",
    "label": "Traits de caractère souhaités",
    "placeholder": "par ex. Foi inébranlable, maturité émotionnelle, gentillesse dans le stress…",
    "hint": "Écrivez au moins des caractères {min} sur le partenaire que vous espérez."
  },
  "loveReady": {
    "eyebrow": "Seuil",
    "title": "Êtes-vous prêt à rencontrer l'amour de votre vie ?",
    "text": "UN8 existe pour que les célibataires sérieux trouvent un partenaire, puis supprimez l'application. Seuls les déverrouillages « Oui » continuent.",
    "yesTitle": "Oui, je suis prêt",
    "yesBody": "Je suis ici pour rencontrer ma personne avec clarté et courage.",
    "noTitle": "Pas encore",
    "noBody": "Si vous ne faites que naviguer, cette communauté n'est pas la bonne solution.",
    "comeBackTitle": "Revenez quand vous êtes prêt",
    "comeBackBody": "UN8 est destiné aux personnes prêtes à se rencontrer et non à collecter des options. Utilisez Quitter ci-dessous si vous souhaitez vous arrêter pour le moment. Vos réponses sont enregistrées sur ce téléphone.",
    "hintNo": "Seul « Oui » continue. Si vous n'êtes pas prêt, appuyez sur Quitter pour l'instant : vos réponses restent sur ce téléphone.",
    "hintUnset": "Appuyez sur Oui si vous êtes prêt à rencontrer quelqu'un pour le mariage."
  },
  "lifestyle": {
    "eyebrow": "Mode de vie",
    "title": "Comment tu vis au jour le jour",
    "text": "Sports, loisirs, lecture et profession : des signaux pratiques pour une réelle compatibilité.",
    "hobbies": "Sports ou passe-temps actuels",
    "hobbiesPlaceholder": "Ce que vous faites activement – ​​pas ce que vous faisiez autrefois.",
    "reading": "Lisez-vous?",
    "readingHint": "1 = presque jamais · 10 = lecture quotidienne et approfondie",
    "profession": "Métier / secteur",
    "professionPlaceholder": "par ex. Soins infirmiers · Logiciels · Éducation · Métiers",
    "hintHobbies": "Nommez au moins un sport ou un passe-temps que vous pratiquez réellement.",
    "hintReading": "Diapositive « Lisez-vous ? » donc un nombre de 1 à 10 apparaît.",
    "hintProfession": "Tapez le travail que vous faites, même un mot court."
  },
  "faithDepth": {
    "eyebrow": "Correspondance · Foi",
    "title": "Dans quelle mesure votre foi est-elle centrale ?",
    "text": "Servir Dieu : quelle importance dans votre vie ? Répondez honnêtement. La correspondance utilise cela pour la profondeur, pas pour les performances.",
    "serving": "Servir Dieu – importance",
    "servingHint": "10%… 100%. Faites glisser par étapes de 10.",
    "keepsCommandments": "Respectez-vous les commandements ?",
    "grewUpInChurch": "Avez-vous grandi à l'église ?",
    "churchAttendance": "Fréquentation de l'église",
    "frequent": {
      "label": "Fréquent",
      "hint": "Rassemblement régulier avec le corps du Christ."
    },
    "seldom": {
      "label": "Rarement",
      "hint": "Parfois, ce n'est pas un rythme hebdomadaire."
    },
    "never": {
      "label": "Jamais",
      "hint": "Je ne participe pas actuellement."
    },
    "spreadsGospel": "Répandez-vous l’Évangile ?",
    "hasIdols": "Avez-vous des idoles ?",
    "hintServing": "Faites glisser à quel point il est important de servir Dieu dans votre vie.",
    "hintCommandments": "Répondez si vous respectez les commandements – Oui ou Non.",
    "hintGrewUp": "Répondez si vous avez grandi dans l’église – Oui ou Non.",
    "hintAttendance": "Choisissez la fréquence à laquelle vous allez à l'église.",
    "hintGospel": "Répondez si vous partagez l’Évangile – Oui ou Non.",
    "hintIdols": "Répondez si vous avez des idoles – Oui ou Non."
  },
  "character": {
    "eyebrow": "Correspondance · Caractère",
    "title": "Qui es-tu à la maison",
    "text": "Caractère pour la cour – rétablissement de la paix, bonnes manières, honnêteté. Les réponses gonflées ne vous correspondent que plus tard.",
    "peacemaker": "Êtes-vous un artisan de la paix ?",
    "homebuilder": "Êtes-vous un constructeur de maisons?",
    "humorous": "Etes-vous humoristique ?",
    "caring": "Attentionné et affectueux ?",
    "peacefulHome": "Voulez-vous une maison paisible, sans combats ?",
    "manners": "Bonnes manières?",
    "honestyRating": "Évaluation de l'honnêteté sur ce questionnaire",
    "honestyHint": "1 à 10 – avec quelle honnêteté répondez-vous ?",
    "hintPeacemaker": "Répondez à chaque oui ou non, en commençant par pacificateur.",
    "hintHomebuilder": "Répondez si vous êtes un constructeur de maisons.",
    "hintHumorous": "Répondez si vous êtes humoristique.",
    "hintCaring": "Répondez si vous êtes attentionné et affectueux.",
    "hintPeaceful": "Répondez si vous voulez une maison paisible.",
    "hintManners": "Répondez si vous avez de bonnes manières.",
    "hintHonesty": "Faites glisser votre note d'honnêteté de 1 à 10."
  },
  "history": {
    "eyebrow": "Correspondance · Historique",
    "title": "Passé et préparation",
    "text": "Substances, enfance, cicatrices et si vous êtes prêt pour une relation durable. La vérité ici vous protège tous les deux.",
    "marijuana": "Avez-vous consommé de la marijuana?",
    "lsd": "Avez-vous consommé du LSD ?",
    "otherDrugs": "Avez-vous consommé d'autres drogues ?",
    "addicted": "Avez-vous été accro?",
    "childhood": "Une enfance stable et aimante ?",
    "scars": "Des cicatrices/des dommages ?",
    "lasting": "Prêt pour une relation durable ?",
    "hintStart": "Répondez à chaque oui ou non sur cette page, en commençant par le haut.",
    "hintLsd": "Répondez à la question sur le LSD – Oui ou Non.",
    "hintOtherDrugs": "Répondez si vous avez consommé d’autres drogues.",
    "hintAddicted": "Répondez si vous êtes accro.",
    "hintChildhood": "Répondez si votre enfance a été stable et aimante.",
    "hintScars": "Répondez si vous portez des cicatrices.",
    "hintLasting": "Répondez si vous êtes prêt pour une relation durable."
  },
  "appearance": {
    "eyebrow": "Correspondance · Apparence",
    "title": "Tatouages",
    "text": "Vos tatouages ​​et si les tatouages ​​​​sur un partenaire vous conviennent.",
    "hasTattoos": "As-tu des tatouages ​​?",
    "acceptsPartner": "Accepter les tatouages ​​sur un partenaire ?",
    "hintHas": "Dites si vous avez des tatouages ​​– Oui ou Non.",
    "hintAccepts": "Dites si les tatouages ​​​​sur un partenaire vous conviennent."
  },
  "home": {
    "eyebrow": "Matching · Maison et terrain",
    "title": "Terre, compétences, autosuffisance",
    "text": "Herbes, culture d'aliments, forêt fruitière, préparation, agriculture communautaire, conservation, survie – et toutes compétences particulières.",
    "herbKnowledge": "Connaissance des herbes ?",
    "plantOwn": "Plantez-vous vos propres fruits et légumes ?",
    "fruitForest": "Une forêt fruitière vous intéresse ?",
    "prepping": "Vous vous préparez aux calamités ?",
    "communityFarming": "Agriculture communautaire / vie indépendante ?",
    "canning": "Mise en conserve et conservation ?",
    "survival": "Compétences de survie ?",
    "specialSkills": "Compétences particulières (facultatif)",
    "specialPlaceholder": "Tout ce que vous apportez à un foyer ou à un terrain…",
    "hintStart": "Répondez à chaque oui ou non sur le terrain et les compétences, en commençant par le haut.",
    "hintPlant": "Répondez si vous plantez vos propres fruits et légumes.",
    "hintFruitForest": "Répondez si une forêt fruitière vous intéresse.",
    "hintPrepping": "Répondez si vous vous préparez à des calamités.",
    "hintCommunity": "Répondez si l’agriculture communautaire vous intéresse.",
    "hintCanning": "Répondez si vous le pouvez et conservez les aliments.",
    "hintSurvival": "Répondez si vous avez des compétences de survie."
  },
  "family": {
    "eyebrow": "Correspondance · Famille",
    "title": "Enfants, profondeur de la foi, substances",
    "text": "Ce dont vous avez besoin chez un partenaire en termes d’intensité de foi, d’enfants et de consommation antérieure de substances.",
    "children": "Enfants",
    "wants": {
      "label": "Veut des enfants",
      "hint": "Fonder une famille fait partie de la vision."
    },
    "doesNotWant": {
      "label": "Ne veut pas d'enfants",
      "hint": "Clairement non sur les enfants."
    },
    "open": {
      "label": "Ouvrir",
      "hint": "Discernant – pas verrouillé de toute façon."
    },
    "hasLivingWith": {
      "label": "A des enfants – vit avec eux",
      "hint": "Les enfants font déjà partie du quotidien."
    },
    "requiredFaith": "Niveau de foi minimum dont vous avez besoin chez un partenaire",
    "requiredFaithHint": "10%… 100%. Porte dure lorsque les deux côtés ont répondu.",
    "acceptsSubstances": "Accepter la consommation passée de substances chez un partenaire ?",
    "hintChildren": "Choisissez une carte sur les enfants.",
    "hintFaith": "Faites glisser le niveau de foi minimum que vous espérez chez un partenaire.",
    "hintSubstances": "Dites si la consommation antérieure de substances chez un partenaire est acceptable."
  },
  "ancestry": {
    "eyebrow": "Correspondance · Contexte",
    "title": "Préférences d'arrière-plan",
    "text": "Partagez votre parcours et ce à quoi vous êtes ouvert chez un partenaire. Cela ne fait que façonner le classement – ​​cela ne cache jamais quelqu'un du jeu.",
    "yourBackground": "Votre parcours (sélectionnez tout ce qui s'applique)",
    "openToPartner": "Ouvert à chez un partenaire",
    "codeDesc": "Code : {code}",
    "anyDesc": "Préférence la plus forte pour la largeur – recommandé en cas de doute.",
    "preferenceOnly": "Préférence uniquement – ​​pas de porte.",
    "hintOwn": "Cochez au moins un contexte qui vous décrit. Cela ne fait qu’aider au classement – ​​cela ne cache jamais personne.",
    "hintAccepted": "Cochez ce à quoi vous êtes ouvert chez un partenaire, ou « Ouvert – aucune préférence »."
  },
  "interests": {
    "eyebrow": "Correspondance · Intérêts",
    "title": "Ce que tu apprécies",
    "text": "Choisissez-en au moins un. Le chevauchement aide au classement ; le silence n'est jamais puni.",
    "hint": "Cochez au moins un intérêt."
  },
  "reflection": {
    "eyebrow": "Correspondance · Réflexion",
    "title": "Dans tes propres mots",
    "text": "Ces quatre réponses sont présentées dans leur intégralité et jamais notées. Écrivez ce qui est vrai.",
    "describeYourself": "Décrivez-vous",
    "lifePurpose": "But de la vie",
    "fifteenYear": "Toi et l'amour de ta vie dans 15 ans",
    "weaknesses": "Faiblesses",
    "hintDescribe": "Décrivez-vous au moins en caractères {min}.",
    "hintPurpose": "Écrivez le but de votre vie avec au moins des caractères {min}.",
    "hintVision": "Écrivez la vision sur 15 ans avec au moins des caractères {min}.",
    "hintWeaknesses": "Nommez une faiblesse dans au moins les caractères {min}."
  },
  "profile": {
    "eyebrow": "Profil",
    "title": "Quelques incontournables",
    "text": "Restez simple. Le sexe est ici binaire – masculin ou féminin – pour une correspondance claire.",
    "firstName": "Prénom",
    "firstNamePlaceholder": "Comme tu souhaites être connu",
    "age": "Âge",
    "agePlaceholder": "18+",
    "city": "Ville",
    "cityPlaceholder": "Où vous êtes basé",
    "sex": "Sexe",
    "maleBody": "Je suis un homme.",
    "femaleBody": "Je suis une femme.",
    "hintName": "Tapez votre prénom (au moins deux lettres).",
    "hintAge": "L'âge doit être de 18 ans ou plus.",
    "hintCity": "Tapez la ville où vous habitez.",
    "hintGender": "Choisissez Homme ou Femme pour que la correspondance puisse fonctionner."
  },
  "ready": {
    "title": "Vous pouvez entrer.",
    "textNamed": "{name}, votre vérification et votre configuration sont enregistrées. Le support est pending_review. Bienvenue sur UN8 : recherchez votre personne, puis supprimez l'application.",
    "text": "Votre vérification et votre configuration sont enregistrées. Le support est pending_review. Bienvenue sur UN8 : recherchez votre personne, puis supprimez l'application.",
    "summaryAria": "Résumé de la configuration",
    "christianRules": "Chrétien · règles affirmées",
    "mediaLine": "ID · vidéo · photos {photoCount} · file d'attente {pending}",
    "scalesLine": "Balances L{loyalty}/H{honesty}/P{passion}/C{commitment}",
    "genderProfession": "{gender} · {profession}",
    "sexUnset": "Sexe —",
    "professionFallback": "profession",
    "userLine": "Utilisateur {userId}",
    "enterMatching": "Entrez la correspondance",
    "needGender": "Revenez à l'étape du profil et choisissez Homme ou Femme, puis réessayez."
  },
  "match": {
    "brandTag": "Correspondance",
    "navOnboarding": "Intégration",
    "navReview": "Revoir",
    "navMatching": "Correspondance",
    "logOut": "Se déconnecter",
    "enterTitle": "Entrez la correspondance",
    "enterText": "Connectez-vous avec le même e-mail lors de l'intégration. L’application, le pool, les likes et les correspondances utilisent tous votre identifiant utilisateur stable.",
    "email": "E-mail",
    "emailPlaceholder": "vous@exemple.com",
    "password": "Mot de passe",
    "passwordPlaceholder": "Votre mot de passe",
    "logIn": "Se connecter",
    "guestOr": "Ou essayez une session invité (identifiant stable par navigateur · démo uniquement)",
    "guestMan": "Invité en tant qu'homme",
    "guestWoman": "Invitée en tant que femme",
    "goOnboarding": "Accédez à l'intégration →",
    "guestSession": "Session invité · pool de démonstration",
    "packTitle": "Vos quatre",
    "packSkip": "Touchez pour continuer",
    "newSelection": "Nouvelle sélection",
    "backToFour": "← Retour à vos quatre",
    "whoLikedTitle": "Who liked you",
    "whoLikedLocked": "Subscribe to see names on the weekly deck — inbound hearts still show on Messages.",
    "whoLikedEmpty": "No one new has liked you yet.",
    "man": "homme",
    "woman": "femme",
    "navSelection": "Sélection",
    "navMessages": "Messages",
    "navProfile": "Profil",
    "tabToday": "Sélection",
    "tabMatches": "Correspondances ({count})",
    "yourMatches": "Vos matchs",
    "matchesSub": "Intérêt mutuel persistant · {count} sortant {likesWord}",
    "like": "comme",
    "likes": "goûts",
    "emptyMatches": "Pas encore d’intérêt mutuel. Continuez à discerner la sélection de cette semaine.",
    "valuesScore": "Valeurs {score}",
    "chatOpen": "· Chat ouvert",
    "tapToChat": "· Appuyez pour discuter",
    "personLine": "{name}, {age}",
    "cityValues": "{city} · Valeurs {score}",
    "noProfileYet": "Pas encore de profil",
    "noProfileText": "Terminez l’intégration ou appuyez sur Intégration en haut, puis sur Commencer. La correspondance des invités se fait sur l'écran de saisie si vous souhaitez seulement regarder.",
    "matchingPaused": "Correspondance suspendue",
    "moderationDemoNote": "Showing demo people so you can try matching while you wait.",
    "noOneYet": "Personne à montrer pour l'instant",
    "todaysSetDone": "C’est la sélection de cette semaine",
    "weeklyTitle": "Vos 4 de cette semaine",
    "weeklyTitleCount": "Vos {count} de cette semaine",
    "weeklyCountdown": "Prochaine sélection dans {days} jours",
    "weeklyCountdownOne": "Prochaine sélection dans 1 jour",
    "weeklyCountdownSoon": "Prochaine sélection bientôt",
    "shortWeekCopy": "This week there are {count}. We never suggest someone who is not a fit.",
    "shortWeekTwo": "This week there are two. We never suggest someone who is not a fit.",
    "weekDone": "C’est la sélection de cette semaine",
    "weekDoneText": "You have discerned everyone we could honestly suggest. Come back when the next selection opens.",
    "emptyNeverHad": "Personne dans la liste de cette semaine pour l’instant. Le groupe se remplit — rouvrez Sélection dans un instant, ou revenez quand d’autres membres seront approuvés.",
    "emptyDone": "Vous avez parcouru la sélection de cette semaine. Revenez à la prochaine ouverture, ou réinitialisez le jeu.",
    "likesMayNotStick": "Les likes peuvent ne pas rester.",
    "poolMeta": "Pool : {pool} · Matchs : {matches} · J'ai aimé : {liked}",
    "demoPool": "démo",
    "livePool": "{source} ({count})",
    "resetDeck": "Réinitialiser le jeu",
    "backOnboarding": "Retour à l'intégration",
    "feedEyebrowDemo": "Sélection de la semaine · Démo",
    "feedEyebrowLive": "Sélection de la semaine · Pool ({source}, {count})",
    "feedTitle": "Discerner avec soin",
    "left": "encore {count}",
    "pass": "Passer",
    "interested": "Intéressé",
    "swipeHint": "Faites glisser ou utilisez les boutons. Un match ne s’ouvre que lorsque l’intérêt est mutuel et persistant.",
    "celebrationEyebrow": "Intérêt mutuel",
    "celebrationTitle": "Vous correspondiez",
    "celebrationText": "{self} et {other} ont tous deux manifesté leur intérêt. Alignement des valeurs : {score}.",
    "celebrationWhyLabel": "Why you matched",
    "celebrationNote": "Le chat est débloqué pour ce match. Gardez-le respectueux – alliance plutôt que commodité.",
    "openChat": "Ouvrir le chat",
    "keepDiscerning": "Continuez à discerner",
    "cardSeeking": "En cherchant",
    "cardHobbies": "Loisirs",
    "affinity": "Affinité",
    "valuesScoreLabel": "Score des valeurs",
    "scoreStrong": "Fort alignement",
    "scoreSolid": "Alignement solide",
    "scoreModerate": "Alignement modéré",
    "scoreDifferent": "Différents rythmes",
    "characterAxisFoot": "L'axe des personnages comprend les quatre piliers",
    "youThem": "Vous {self} · Eux {other}",
    "stampInterest": "Intérêt",
    "stampPass": "Passer",
    "explainLikedYou": "They already liked you — this is mutual interest waiting to happen.",
    "explainLegacyClose": "Vos scores de valeurs sont proches les uns des autres ({score} sur 100).",
    "explainLegacyFuller": "Un « pourquoi » plus complet apparaît une fois que vous avez tous deux répondu aux questions correspondantes.",
    "explainFaith": "L’intensité de votre foi est proche – vous suivez Jésus avec le même sérieux.",
    "explainCharacter": "La façon dont vous traitez les gens à la maison dépend de la paix, des bonnes manières et des soins.",
    "explainPurpose": "Vous avez évalué votre propre honnêteté de la même manière, ce qui est le signe d’un sérieux partagé.",
    "explainHome": "Vous partagez un intérêt pour la terre, la culture de nourriture ou une maison autosuffisante.",
    "explainAncestry": "Vous préférez tous les deux des antécédents familiaux similaires. Il s’agit d’une préférence, pas d’un filtre : personne n’est caché pour cela.",
    "explainTemperament": "Vos intérêts et votre tempérament se chevauchent.",
    "explainFallback": "Il existe une correspondance possible entre les réponses que vous avez fournies tous les deux.",
    "explainOverall": "Affinité globale {score} de 100.",
    "affinityAxes": {
      "faith": "Intensité de la foi",
      "character": "Caractère et conduite",
      "purpose": "Alignement sur le but de la vie",
      "home": "Maison et autonomie",
      "ancestry": "Affinité culturelle et historique",
      "temperament": "Ajustement du tempérament"
    },
    "scaleAxes": {
      "loyalty": "Loyauté",
      "honesty": "Honnêteté",
      "passion": "Passion",
      "commitment": "Engagement"
    },
    "verify": {
      "brandTag": "Verify",
      "title": "Verify to message",
      "sub": "Anyone can browse and heart. A conversation needs your ID and a short confirmation video. Submitted is enough — review can wait.",
      "cta": "Add ID and video",
      "videoCta": "Add a confirmation video",
      "submitted": "ID and video are in. You can message while we review.",
      "done": "You’re verified.",
      "back": "Back",
      "continue": "Continue",
      "idEyebrow": "Identity",
      "videoEyebrow": "Presence",
      "idText": "Passport or national ID. Nothing is posted publicly. Submitted is enough to talk.",
      "videoText": "A short clip (about {seconds} seconds). Face the camera. This proves you are present."
    }
  },
  "chat": {
    "brandTag": "Chat",
    "unavailableTitle": "Chat indisponible",
    "unavailableText": "Cette correspondance est manquante ou n'appartient pas à votre session.",
    "backToMatches": "Retour aux correspondances",
    "backMatches": "← Correspondances",
    "valuesSubscriber": "Valeurs {score} · Abonné",
    "valuesTrial": "Valeurs {score} · Essai",
    "valuesKept": "Valeurs {score} · Correspondance conservée",
    "empty": "Dites bonjour avec précaution. Sur le backend partagé, les messages se synchronisent sur les deux téléphones après une correspondance mutuelle.",
    "placeholder": "Message {name}…",
    "ariaMessage": "Message",
    "send": "Envoyer"
  },
  "billing": {
    "paywallCopy": "Après votre essai gratuit, gardez toutes les personnes avec qui vous avez déjà été en contact et continuez à discuter. Pour voir de nouvelles personnes, abonnez-vous.",
    "signInToMatch": "Connectez-vous pour utiliser la correspondance.",
    "signInFirst": "Connectez-vous d'abord.",
    "subscriberUntil": "Abonné · jusqu'à {date}",
    "renewal": "renouvellement",
    "freeTrial": "Essai gratuit · Jours {days} (termine {date})",
    "soon": "bientôt",
    "trialEnded": "Essai terminé · les matchs et le chat restent ouverts",
    "subscribe": "S'abonner · ${price}/mois",
    "subscribeEarly": "Abonnez-vous tôt · ${price}/mois",
    "activeNote": "Abonnement actif – vous pouvez revoir de nouvelles personnes.",
    "playOnly": "Subscription is Google Play Billing only (app install). There is no web checkout here.",
    "playOnlyShort": "Billing via Google Play only — no web payment."
  },
  "auth": {
    "recoveryTitle": "Enregistrez votre code de récupération",
    "recoveryText": "Écrivez ceci maintenant. Il est affiché une fois. Si vous perdez votre phrase secrète, ce code est le seul moyen de la réinitialiser lors du test fermé.",
    "savedContinue": "Je l'ai enregistré — continuer",
    "welcomeBack": "Content de te revoir",
    "createAccount": "Créez votre compte",
    "intro": "Poignée et phrase secrète. Aucun email ni SMS n'est envoyé. Votre identifiant reste stable lors de l'intégration, de la révision et de la mise en correspondance.",
    "tabLogin": "Se connecter",
    "tabRegister": "Registre",
    "handle": "Poignée",
    "handlePlaceholder": "you@example.com ou un court identifiant",
    "passphrase": "Phrase secrète",
    "passphrasePlaceholder": "Au moins 8 caractères",
    "submitLogin": "Se connecter",
    "submitRegister": "Créer un compte",
    "backWelcome": "Retour à l'accueil"
  },
  "options": {
    "origin": {
      "african": "africain",
      "european": "européen",
      "asian": "asiatique",
      "latino": "Latino/Hispanique",
      "middleEastern": "Moyen-Orient",
      "indigenous": "Indigène",
      "mixed": "Mixte",
      "other": "Autre",
      "dutch": "Néerlandais",
      "german": "Allemand",
      "any": "Ouvert — aucune préférence"
    },
    "interest": {
      "prayer": "Prière",
      "worship": "Culte",
      "reading": "En lisant",
      "hiking": "Randonnée",
      "music": "Musique",
      "cooking": "Cuisson",
      "farming": "Agriculture/jardinage",
      "sports": "Sportif",
      "missions": "Missions",
      "family": "La vie de famille",
      "crafts": "Artisanat",
      "outdoors": "En plein air"
    }
  },
  "capture": {
    "yesNoDefaults": {
      "yes": "Oui",
      "no": "Non"
    },
    "id": {
      "titleEmpty": "Carte d'identité gouvernementale",
      "titleReady": "Carte d'identité prête",
      "hintEmpty": "Passeport ou carte d'identité nationale. Prenez une photo en direct ou choisissez une image/PDF. Les quatre coins visibles.",
      "hintReady": "{fileName} · {bytes}{saved}",
      "savedSuffix": "· enregistré",
      "previewAlt": "Aperçu de la pièce d'identité gouvernementale",
      "pdfAria": "Document PDF sélectionné",
      "takePhoto": "Prendre une photo",
      "retake": "Reprendre",
      "chooseFile": "Choisir un fichier",
      "replaceFile": "Remplacer le fichier",
      "remove": "Retirer",
      "uploading": "Téléchargement…",
      "cameraTitle": "Photographiez votre pièce d'identité",
      "signIn": "Connectez-vous avant de télécharger votre identifiant.",
      "uploadFailed": "Le téléchargement a échoué. Essayer à nouveau.",
      "badFile": "Impossible d'utiliser ce fichier."
    },
    "video": {
      "titleEmpty": "Vidéo de confirmation",
      "titleLive": "Caméra en direct",
      "titleReady": "Vidéo prête",
      "hintEmpty": "Dites votre prénom et rejoignez UN8 honnêtement. 5 à 15 secondes.",
      "hintReady": "{fileName} · {bytes}{saved}",
      "rec": "REC {seconds}s",
      "record": "Enregistrer",
      "cameraUpload": "Téléchargement de la caméra",
      "chooseFile": "Choisir un fichier",
      "startRecording": "Commencer l'enregistrement",
      "cancel": "Annuler",
      "stopSave": "Arrêtez et enregistrez",
      "recordAgain": "Enregistrer à nouveau",
      "replaceFile": "Remplacer le fichier",
      "remove": "Retirer",
      "unsupported": "L'enregistrement en direct n'est pas disponible ici. Utilisez le téléchargement par caméra ou choisissez un fichier.",
      "permissionDenied": "Autorisation de la caméra refusée. Vous pouvez toujours télécharger un court fichier vidéo.",
      "signIn": "Connectez-vous avant de télécharger la vidéo.",
      "uploadFailed": "Le téléchargement a échoué. Essayer à nouveau.",
      "saveFailed": "Impossible de sauvegarder l'enregistrement.",
      "badVideo": "Impossible d'utiliser cette vidéo."
    },
    "photos": {
      "count": "Photos {count} / {max}",
      "minimumMet": "Minimum atteint",
      "moreRequired": "{n} plus requis",
      "listAria": "Photos de vérification",
      "photoAlt": "Photo {n}",
      "removeAria": "Supprimer la photo {n}",
      "camera": "Caméra",
      "takePhoto": "Prendre une photo",
      "chooseFiles": "Choisir des fichiers",
      "uploading": "Téléchargement…",
      "hint": "Prendre une photo ouvre la caméra en direct. Choisir des fichiers est uniquement destiné aux choix de galerie. Des photos de visage claires – pas de filtres qui cachent l’identité. Max {max}.",
      "cameraTitle": "Prenez une photo de vous",
      "signIn": "Connectez-vous avant de télécharger des photos.",
      "someFailed": "Certaines photos n'ont pas pu être téléchargées. Réessayez ceux qui ont échoué.",
      "addFailed": "Impossible d'ajouter des photos."
    },
    "liveStill": {
      "titleDefault": "Caméra",
      "close": "Fermer",
      "capture": "Capturer",
      "cancel": "Annuler",
      "hint": "Tenez bon. La caméra en direct reste ouverte jusqu'à ce que vous capturiez.",
      "unavailable": "L'appareil photo n'est pas disponible dans ce navigateur. Utilisez plutôt Choisir un fichier.",
      "permissionDenied": "Autorisation de la caméra refusée ou indisponible. Utilisez plutôt Choisir un fichier.",
      "frameFailed": "Impossible de capturer cette image.",
      "saveFailed": "Impossible d'enregistrer la photo."
    },
    "uploadStatus": {
      "uploading": "téléchargement…",
      "failed": "échec du téléchargement",
      "savedLocally": "enregistré localement",
      "uploaded": "téléchargé",
      "stored": "stocké",
      "awaitingUpload": "En attente de téléchargement",
      "localFallbackNote": "Le fichier {error} est enregistré sur cet appareil ; réessayez lorsque le point de terminaison de signe est actif."
    }
  },
  "language": {
    "label": "Langue",
    "choose": "Choisir la langue"
  },
  "shell": {
    "back": "Dos",
    "goBackAria": "Retourner"
  }
} as Messages;
